import { gql, useQuery } from "@apollo/client";
import React from "react";
import { Link } from "react-router-dom";
import { Loading } from "../../../../components/Loading";
import { Graph } from "../../../../generated/graph";

const QUARY_LOGINLESS_ORDER = gql`
  query QUARY_LOGINLESS_ORDER {
    loginlessOrderList(status: PENDING, offset: 0, limit: 200) {
      id
      phoneNumber
      total
      status
      customerName
      unreachableCount
      unreachableAt
      lastReviewAt
    }
  }
`;

function roundNumber(value: number) {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function renderRow(data: Graph.LoginlessOrder[]) {
  return (
    <table className="table table-padded">
      <thead>
        <tr>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Total Price</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => {
          return (
            <tr key={item.id.toString()}>
              <td>{item.customerName}</td>
              <td>0{item.phoneNumber}</td>
              <td>${roundNumber(Number(item.total))}</td>
              <td className="text-center">
                <Link className="btn btn-primary btn-sm" to={`/orders/loginless/detail/${item.id}` }>Review</Link>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function renderLockRow(data: Graph.LoginlessOrder[]) {
  return (
    <div className="mt-5">
      <h4>Reviewing</h4>
      <table className="table table-padded">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone Number</th>
            <th>Total Price</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id.toString()}>
              <td>{item.customerName}</td>
              <td>0{item.phoneNumber}</td>
              <td>${roundNumber(Number(item.total))}</td>
              <td className="text-center">
                <Link className="btn btn-primary btn-sm" to={`/orders/loginless/detail/${item.id}` }>Review</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function renderUnreachbleRow(data: Graph.LoginlessOrder[]) {
  return (
    <table className="table table-padded">
      <thead>
        <tr>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Total Price</th>
          <th>Unreachable</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr key={item.id.toString()}>
            <td>{item.customerName}</td>
            <td>0{item.phoneNumber}</td>
            <td>${roundNumber(Number(item.total))}</td>
            <td>{item.unreachableCount}</td>
            <td>
              {new Date(item.unreachableAt || "").toLocaleDateString() +
                " " +
                new Date(item.unreachableAt || "").toLocaleTimeString()}
            </td>
            <td className="text-center">
              <Link className="btn btn-primary btn-sm" to={`/orders/loginless/detail/${item.id}` }>Review</Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function renderBody(data: Graph.LoginlessOrder[]) {
  const pendingOrder = data.filter((x) => (x.unreachableCount || 0) === 0);
  const unreviewOrder = pendingOrder.filter(
    (x) => !x.lastReviewAt || x.lastReviewAt + 60000 < Date.now()
  );
  const reviewOrder = pendingOrder.filter(
    (x) => x.lastReviewAt && x.lastReviewAt + 60000 > Date.now()
  );
  const unreachableOrder = data.filter((x) => (x.unreachableCount || 0) > 0);

  return (
    <div>
      {renderRow(unreviewOrder)}
      {reviewOrder.length > 0 && renderLockRow(reviewOrder)}
      {unreachableOrder.length > 0 && (
        <div className="mt-5">
          <h4>Unreachable</h4>
          {renderUnreachbleRow(unreachableOrder)}
        </div>
      )}
    </div>
  );
}

export function LoginLessOrderPanding() {
  const { data, loading } = useQuery<Graph.Query>(QUARY_LOGINLESS_ORDER);

  if (loading || data === undefined) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  return data!.loginlessOrderList ? (
    renderBody(data!.loginlessOrderList)
  ) : (
    <Loading />
  );
}
